import React, { useEffect, useState } from "react";
import { CheckCircle } from "@mui/icons-material";
import { Link } from "react-scroll"; // Import smooth scroll
const About = () => {
  return (
    <section className=" common-flex">
      <div className="mission-m-left">
        <p className=" mission-item">
          <CheckCircle fontSize="small" style={{ verticalAlign: 'sub', color: "white", backgroundColor: "green", borderRadius: "50%", padding: "3px" }} />
          <span>
            <p className="mission-common-title">Our Mission</p>
            <p className="mission-subtitle">
              To revolutionize the way fresh fruits and vegetables reach customers by ensuring premium quality, sustainability, and affordability, while empowering farmers across India with better opportunities and fair farm produce pricing. Our mission is to build a reliable farm-to-consumer marketplace in India that guarantees organic freshness from farm to table, connecting local farmers directly with health-conscious consumers.
            </p>

          </span>
        </p>

        <p className="mission-item mission-m-t">
          <CheckCircle fontSize="small" style={{ verticalAlign: 'sub', color: "white", backgroundColor: "green", borderRadius: "50%", padding: "3px" }} />
          <span>
            <p className="mission-common-title">Our Vision</p>
            <p className="mission-subtitle">
              To create a sustainable agricultural ecosystem that benefits both farmers and consumers. We envision a future where organic fruits and vegetables delivery becomes the standard for every Indian household seeking farm-fresh groceries online. Our goal is to lead India toward a healthier lifestyle through eco-friendly and transparent farm produce supply chains.
            </p>
          </span>
        </p>
        <p className="mission-item mission-m-t">
          <CheckCircle fontSize="small" style={{ verticalAlign: 'sub', color: "white", backgroundColor: "green", borderRadius: "50%", padding: "3px" }} />
          <span>
            <p className="mission-common-title">Our Journey</p>
            <p className="mission-subtitle">
              Founded in 2016, MandiGate Private Limited connects farmers and consumers directly, offering fresh, organic, and healthy produce online. As one of India’s fastest-growing fresh produce suppliers, we ensure quality assurance, efficient logistics, and a seamless experience through our digital farm-to-table platform.
            </p>
          </span>
        </p>
        <p className="mission-item mission-m-t">
          <CheckCircle fontSize="small" style={{ verticalAlign: 'sub', color: "white", backgroundColor: "green", borderRadius: "50%", padding: "3px" }} />
          <span>
            <p className="mission-common-title">Our Leadership</p>
            <p className="mission-subtitle">
              MandiGate Private Limited was founded by Mr. Yogesh Saini, a visionary entrepreneur passionate about revolutionizing India’s agricultural supply chain. Under his leadership, MandiGate has become a trusted name in the fresh produce marketplace, known for quality, reliability, and innovation in the farm-fresh delivery sector.
            </p>
          </span>
        </p>
      </div>
      <div className="right-container-common pdding-left-40">
        <div className="who-are-width">
          <p className="common-title who-are-m-t">Who We Are?</p>
          <div>
            <p className="common-subtitle">
              At MandiGate, we are more than just a supplier of fresh fruits and vegetables — we are a movement toward healthy living and sustainable farming practices in India. Our foundation is built on trust, quality, and transparency, ensuring customers always receive the best farm-fresh produce online. We connect local farmers to homes across India, creating an impactful link between farmers and conscious consumers.
            </p>

          </div>
        </div>

      </div>
    </section>
  );
};

export default About;
